module.exports = __webpack_public_path__ + "img/caidan.f047c3ae.png";